import "./App.scss";

import { Container } from "./styles";
import {
  Route,
  BrowserRouter as Router,
  Switch,
  Redirect,
} from "react-router-dom";
//actions to disptach
import { useSelector } from "react-redux";
import { FaInfoCircle } from "@react-icons/all-files/fa/FaInfoCircle";
//Lib Components

import { Loader_SC } from "./components/Loader";
import { ModalMessage } from "./components/ModalMessage";

//Hooks

//Pages
import { OYS } from "./pages";
import { useAuth, useRect } from "./hooks";

const App = () => {
  const [rect, ref] = useRect();
  const [isAuth] = useAuth(window.location.href, rect);

  const show = useSelector((state) => state.App.show);
  const loading = useSelector((state) => state.App.loading);
  const msgTitle = useSelector((state) => state.App.msgTitle);
  const msg = useSelector((state) => state.App.msg);
  const handleModalCancel = () => {
    //setdisplayModal(false);
  };
  return (
    <Container id="mainLayout" ref={ref}>
      {loading && <Loader_SC loading={loading} />}

      <Router basename={window.location.pathname}>
        <Switch>
          <Route exact path="/">
            <OYS />
          </Route>
          <Redirect from="*" to={"/"} />
        </Switch>
      </Router>

      <ModalMessage
        // eslint-disable-next-line no-undef
        MessageTitle={msgTitle || i18next.t("commons.Modal.Title.Error")}
        Icono={<FaInfoCircle style={{ color: "#3686af" }} />}
        // eslint-disable-next-line no-undef
        msg={msg || i18next.t("commons.Modal.Lead.ErrorSistema")}
        MainButtonText={"Volver a los resultados de la búsqueda"}
        show={show}
        CloseAction={handleModalCancel}
        AltButtonAction={handleModalCancel}
        MainButtonAction={handleModalCancel}
      />
    </Container>
  );
};

export default App;
